import { Policy, PolicyCategory } from 'types/api/policies/policy'

export type TestSuitePolicy = {
  sourceScenarioId: string
  sourceScenarioType: ScenarioType
  testPolicy: Policy
}

export interface TestSuite {
  identifier: string
  name: string
  testResponses: TestSuitePolicy[]
  targetTeamIds: string[]
  createdAt: string
  updatedAt: string
  createdBy: string
  excludedRiskIds: string[]
  isOfficial: boolean
  isDefault: boolean
  description?: string
}

// The Backend will need to know the scenario type
// in order to know how to query it
export enum ScenarioType {
  RECOMMENDED = 'RECOMMENDED',
  SHARED = 'SHARED',
  GENERAL = 'GENERAL'
}

export interface ScenarioToPromote {
  scenarioId: string
  scenarioType: ScenarioType
}

export interface TestSuiteScenarioCreation {
  name: string
  description: string
  policyCategory: PolicyCategory
  scenarioToPromote: ScenarioToPromote
}

export interface TestSuiteCreationRequest {
  name: string
  targetTeamIds: string[]
  scenarios: TestSuiteScenarioCreation[]
  excludedRiskIds: string[]
}

export type TestSuiteScenarioUpdateInfo = {
  description: string
  name: string
  policyCategory: PolicyCategory
  reliabilityTestId: string
  scenarioId: string
  scenarioType: ScenarioType
}

export type TestSuiteUpdateRequest = {
  name: string
  targetTeamIds: string[]
  scenarios: TestSuiteScenarioUpdateInfo[]
  excludedRiskIds: string[]
}
